/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import React from 'react';
import EditableText from 'components/common/EditableText';
import Attributes from 'model/stats/Attributes';

interface StatAttributeProps {
  label: string;
  value: number;
  onUpdate: (newValue: number) => void;
}

const StatAttribute: React.FC<StatAttributeProps> = ({ label, value, onUpdate }) => {
  return (
    <div className={`attribute-${label.toLowerCase()}`}>
      <h4>{label}</h4>
      <EditableText
            type="number"
            min={1}
            max={30}
            width="30px"
            initialValue={value}
            onSave={(newValue: string | number) => onUpdate(Math.max(0, parseInt(newValue as string, 10)))}
      />
      &nbsp;({(value > 9 ? "+" : "")}{Attributes.getBonus(value)})
    </div>
  );
};

export default StatAttribute;
